/**
 * Formatta un delta di prezzo (priceDiff) secondo le convenzioni Home Configurator:
 * - null → '—' (prezzo non disponibile/non applicabile)
 * - 0 → 'Incluso nel capitolato'
 * - altrimenti importo assoluto in EUR (it-IT, 0 decimali) con prefisso + / -
 */
export function formatPriceDiff(delta: number | null): string {
  if (delta === null) return '—';
  if (delta === 0) return 'Incluso nel capitolato';
  const formatted = new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
  }).format(Math.abs(delta));
  return delta > 0 ? `+ ${formatted}` : `- ${formatted}`;
}

/** Formatta un prezzo assoluto (price) in EUR, senza segno. */
export function formatPrice(price: number | null): string {
  if (price === null) return '—';
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
  }).format(price);
}

/**
 * Formatta un valore nella colonna "Valore" del riepilogo (port di ResumeCurrencyFormatter legacy):
 * 0/null → '- €' (incluso nel capitolato); altrimenti EUR it-IT (0 decimali se intero, altrimenti 2).
 */
export function formatResumePrice(value: number | null): string {
  if (!value) return '- €';
  const isInteger = value % 1 === 0;
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: isInteger ? 0 : 2,
  }).format(value);
}
